<template>
    <div id="top-bar">
        <b-button size="sm" variant="outline-primary" v-on:click="$router.go(-1);">Go Back</b-button>
        <b-button size="sm" variant="outline-success" v-on:click="$router.push('/home/');"> Home</b-button>
    </div>
</template>

<script>
    export default {
        name: "Backer",
        methods: {}
    }
</script>

<style scoped>
    #top-bar {
        width: 100%;
        margin: 0;
        padding: 4px;
        display: block;
        z-index:100;
        text-align: left;
    }
</style>


// WEBPACK FOOTER //
// src/components/globals/Backer.vue